/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getTemplatesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_TEMPLATES, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getTemplateById: (id) => {
    const url = `${API_ENDPOINTS.GET_TEMPLATES}/${id}`;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  createTemplate: (data) => {
    return axios.post(API_ENDPOINTS.GET_TEMPLATES, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
        "x-tenant-slug": "default",
      },
    });
  },
};
